import getScenarioStore from '../selectors/getScenarioStore';
import importLazyImports from '../utils/importLazyImports';
import setNextSearchQueryId from '../mutators/setNextSearchQueryId';
import setSearchSessionGuid from '../mutators/setSearchSessionGuid';
import { getGuid } from 'owa-guid';
import { lazySubstrateSearchInitOperation } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
import { searchSessionStarted, startSearchSession } from '../actions/publicActions';
import getSubstrateSearchScenarioBySearchScenarioId from '../utils/getSubstrateSearchScenarioBySearchScenarioId';
import { logUsage } from 'owa-analytics';
import SearchScenarioId from '../store/schema/SearchScenarioId';
import { getXClientFlightsHeaderValue } from '../utils/guidedFormulationExperimentUtilities';

export default orchestrator(startSearchSession, actionMessage => {
    const { actionSource, shouldStartSearch, scenarioId } = actionMessage;
    const store = getScenarioStore(scenarioId);

    // Throw if user is already in a search session.
    if (store.searchSessionGuid) {
        throw new Error('searchSessionGuid should not be set when starting a search session.');
    }

    // Set IDs in the store.
    const searchSessionId = getGuid();
    setSearchSessionGuid(searchSessionId, scenarioId);
    setNextSearchQueryId(getGuid(), scenarioId);

    // Make init request if search box is 3S-powered.
    if (store.isUsing3S) {
        lazySubstrateSearchInitOperation.import().then(substrateSearchInitOperation => {
            substrateSearchInitOperation(
                store.nextSearchQueryId,
                getSubstrateSearchScenarioBySearchScenarioId(scenarioId),
                getXClientFlightsHeaderValue()
            );
        });
    }

    /**
     * After common "start session" work is done, dispatch event to notify
     * consumer that search session has been started.
     */
    searchSessionStarted(actionSource, shouldStartSearch, scenarioId);

    /**
     * Since search session has started, we can kick off imports for other
     * actions, mutators, and orchestrators required for search to speed up
     * user experience.
     */
    importLazyImports();

    logUsage('Search_SessionStarted', [SearchScenarioId[scenarioId], actionSource]);
});
